import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import PermissionRoute from 'components/PermissionRoute';
import NotFound from 'scenes/NotFound';

import Actions from './ConnectActions';
import { ActionStateProvider } from './contexts/ActionStateContext';
import { ConnectStateProvider } from './contexts/ConnectStateContext';
import MyConnects from './MyConnects';

const ActionsWithProvider = ({ ...props }: any) => (
  <ActionStateProvider>
    <Actions {...props} />
  </ActionStateProvider>
);

const Connect = () => {
  const base = '/producer/connect';
  return (
    <ConnectStateProvider>
      <Switch>
        <Redirect exact to={`${base}/myconnects`} path={base} />

        <PermissionRoute
          action='myeduzz:connect:visualizar'
          path={`${base}/:connectId/actions`}
          component={ActionsWithProvider}
        />
        <PermissionRoute action='myeduzz:connect:visualizar' path={`${base}/myconnects`} component={MyConnects} />
        <Route path='*' component={NotFound} />
      </Switch>
    </ConnectStateProvider>
  );
};
export default Connect;
